export function structureTable(root) {
  if (!root) return;

  root.querySelectorAll('table').forEach((table) => {
    table.classList.add('cms-table');
    table.classList.remove('table-row-header', 'table-col-header');
    table.removeAttribute('align');
    table.removeAttribute('border');
    table.removeAttribute('cellpadding');
    table.removeAttribute('cellspacing');
    table.style.width = '';

    const hasThead = !!table.querySelector('thead');
    table.classList.add(hasThead ? 'table-row-header' : 'table-col-header');
  });
}
